import { Routes } from '@angular/router';
import { AuthorizationGuard } from '@softline/auth';

export const bauprofiRoutes: Routes = [
  {
    path: 'bauprofi',
    loadComponent: () => import('./pages/root.component'),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/bauprofi/bauprofi.page').then((o) => o.BauprofiPage),
      },
      {
        path: 'data-carrier-supplier',
        loadComponent: () =>
          import(
            './pages/data-carrier-supplier-search/data-carrier-supplier-search.page'
          ).then((o) => o.DataCarrierSupplierSearchPage),
      },
      {
        path: 'data-carrier-supplier/:id',
        loadComponent: () =>
          import(
            './pages/data-carrier-supplier-export/data-carrier-supplier-export.page'
          ).then((o) => o.DataCarrierSupplierExportPage),
      },
      {
        path: 'mail',
        loadComponent: () => import('./pages/mail/mail.page').then((o) => o.MailPage),
      },
      {
        path: 'novelties',
        loadComponent: () =>
          import('./pages/novelties/novelties.page').then((o) => o.NoveltiesPage),
      },
      {
        path: 'favorites',
        loadComponent: () =>
          import('./pages/favorites/favorites.component').then(
            (o) => o.FavoritesComponent
          ),
      },
      {
        path: 'data-carrier',
        loadComponent: () =>
          import('./pages/data-carrier/data-carrier.component').then(
            (o) => o.DataCarrierComponent
          ),
      },
      {
        path: 'result',
        loadComponent: () =>
          import('./pages/document-result/document-result.component').then(
            (o) => o.DocumentResultComponent
          ),
      },
    ],
    canActivate: [AuthorizationGuard],
  },
];
